import styled from 'styled-components';

import { theme } from '../../common/ui/theme';

export const Link = styled.a`
    color: ${theme.colors.accent.foreground};
    font-weight: ${theme.fontWeights[500]};
    cursor: pointer;

    &:hover {
        // required, because *.less override hover
        // styles for all a tags
        color: ${theme.colors.accent.foreground};
    }
`;
